/**
 * Calculates the expiration date based on dynamic settings
 * @param {Object} params - The parameters for calculating the expiration date
 * @param {string} params.baseDate - The base date to calculate from (ISO string)
 * @param {number} params.value - The value to add (e.g., number of days, months, etc.)
 * @param {string} params.unit - The unit of time ('days', 'weeks', 'months', 'years')
 * @returns {string} The calculated date in ISO format (YYYY-MM-DD)
 */
export const calculateDynamicExpirationDate = ({ baseDate = new Date(), value = 1, unit = 'days' }) => {
    const date = new Date(baseDate);

    switch (unit) {
        case 'days':
            date.setDate(date.getDate() + value);
            break;
        case 'weeks':
            date.setDate(date.getDate() + (value * 7));
            break;
        case 'months':
            date.setMonth(date.getMonth() + value);
            break;
        case 'years':
            date.setFullYear(date.getFullYear() + value);
            break;
    }

    return date.toISOString().slice(0, 10);
};

/**
 * Formats a date according to the specified format
 * @param {string} date - The date to format (ISO string)
 * @param {string} format - The format to use ('en-GB' or 'en-US')
 * @returns {string} The formatted date string
 */
export const formatDate = (date, format = 'en-GB') => {
    return new Date(date).toLocaleDateString(format, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}; 